var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Damage greater than","outlined":"","dense":"","hide-details":"auto","type":"number"},on:{"change":_vm.onChange},model:{value:(_vm.damage),callback:function ($$v) {_vm.damage=$$v},expression:"damage"}})}
var staticRenderFns = []

export { render, staticRenderFns }